import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import AuthService from '@/shared/services/AuthService';
import { LegalEntityQueryKey } from './queryKey';
export const useGetLegalEntityNames = () => {
    const intl = useIntl();
    return useQuery([LegalEntityQueryKey.LegalEntityNames], () => api.base.get('/api/legalentity/names').then(res => res.data), {
        enabled: AuthService.hasFeature('TenantMoore'),
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
